import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import unleashApi from '@src/api/unleash'
import { IFeatureToggle } from '@src/types/featureToggles.types'
import useUser from '@src/composables/user'

export const useFeatureTogglesStore = defineStore('featureToggles', () => {
  const loading = ref(true)
  const error = ref(false)
  const featureToggles = ref<IFeatureToggle[]>([])

  const { user } = useUser()

  const experiments = computed(() => featureToggles.value.filter(({ variant: { enabled } }) => enabled))

  async function loadFeatureToggles(realmId: string): Promise<void> {
    loading.value = true
    error.value = false

    try {
      const { event_tracking_id, language } = user.value
      const { data: { toggles } } = await unleashApi.get(event_tracking_id, realmId, language)
      featureToggles.value = toggles
    } catch {
      error.value = true
    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    error,
    featureToggles,
    experiments,
    loadFeatureToggles
  }
})
